import PropTypes from 'prop-types';
import { Box, Typography, Link } from '@mui/material';

import { Link as ReactLink } from 'react-router-dom'



import moment from 'moment'

import i18n from '@/i18n'
import {
  StatusBadge,
} from './DashboardStyles';
import { VBox } from '@/components/VBox';
import { ReleaseCard } from './ReleaseCard';

export function PitchCard({
  name,
  release,
  slug,
  source,
  pitched,
  releaseSuggestions,
  animationDelay = 0,
}) {
  return (
    <VBox sx={{ animationDelay: `${animationDelay}s` }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          marginBottom: 1
        }}
      >
        {release ? (
          <ReleaseCard sx={{ flex: 1 }} {...release} />
        ) : <Typography>{i18n.t('unknown')}</Typography>}
        <VBox sx={{ alignItems: 'flex-end' }}>
          <Typography sx={{ opacity: 0.5 }}>
            <Link title={moment(pitched).format('YYY-MM-DD HH:mm')} as={ReactLink} to={`/dashboard/pitch/${slug}`}>
              {moment(pitched).isValid() ? moment(pitched).fromNow() : 'Unknown date'}
            </Link>
          </Typography>
          <StatusBadge status={source}>
            {i18n.t(source)}
          </StatusBadge>
        </VBox>
      </Box>
      <VBox>

      </VBox>
    </VBox>
  );
}

PitchCard.propTypes = {
  title: PropTypes.string.isRequired,
  artist: PropTypes.string.isRequired,
  status: PropTypes.oneOf(['pending', 'submitted', 'focus']).isRequired,
  pitchDate: PropTypes.string.isRequired,
  playlist: PropTypes.string.isRequired,
  animationDelay: PropTypes.number,
};
